import { render, staticRenderFns } from "./sampleRule.vue?vue&type=template&id=25137594&scoped=true"
import script from "./sampleRule.vue?vue&type=script&lang=js"
export * from "./sampleRule.vue?vue&type=script&lang=js"
import style0 from "./sampleRule.vue?vue&type=style&index=0&id=25137594&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25137594",
  null
  
)

export default component.exports